import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils";

/** Outer dropdown panel shell (border, clip, shadow). Scroll lives in DropdownPanelScrollBody. */
export const DROPDOWN_PANEL_SHELL_CLASS = cn(
  "overflow-hidden rounded-[10px] border border-(--console-border) bg-white",
  "p-0 shadow-[0_4px_16px_rgb(0_0_0/0.1)]",
);

export const DROPDOWN_PANEL_SCROLL_BODY_CLASS = cn(
  "max-h-60 overflow-x-hidden overflow-y-auto overscroll-y-contain bg-white",
);

export const dropdownPanelItemVariants = cva(
  `
    w-full cursor-pointer rounded-none px-4 py-2.5 text-[13px]
    text-(--console-foreground) outline-none
  `,
  {
    variants: {
      selected: {
        true: cn(
          "bg-white! font-bold text-(--console-text-link)!",
          "disabled:pointer-events-none",
        ),
        false: cn(
          `
            hover:bg-(--console-surface-muted)!
            hover:text-(--console-foreground)!
            focus:bg-(--console-surface-muted)!
            focus:text-(--console-foreground)!
            data-highlighted:bg-(--console-surface-muted)!
            data-highlighted:text-(--console-foreground)!
          `,
        ),
      },
    },
    defaultVariants: {
      selected: false,
    },
  },
);

export const dropdownPanelListRowVariants = cva(
  `
    w-full cursor-pointer list-none rounded-none px-4 py-2.5 text-[13px]
    text-(--console-foreground) outline-none
  `,
  {
    variants: {
      selected: {
        true: "bg-white font-bold text-(--console-text-link)",
        false: "",
      },
      highlighted: {
        true: "bg-(--console-surface-muted)! text-(--console-foreground)!",
        false: `
          hover:bg-(--console-surface-muted)! hover:text-(--console-foreground)!
        `,
      },
    },
    defaultVariants: {
      selected: false,
      highlighted: false,
    },
  },
);

export const DROPDOWN_PANEL_COMMAND_ITEM_CLASS = cn(
  dropdownPanelItemVariants({ selected: false }),
  `
    relative flex items-center justify-start text-left
    data-[selected=true]:bg-(--console-surface-muted)!
    data-[selected=true]:text-(--console-foreground)!
  `,
);

export const DROPDOWN_PANEL_SELECT_ITEM_CLASS = cn(
  dropdownPanelItemVariants({ selected: false }),
  `
    data-[state=checked]:bg-white! data-[state=checked]:font-bold
    data-[state=checked]:text-(--console-text-link)
  `,
);

export const DROPDOWN_PANEL_SEPARATOR_CLASS =
  "m-0 h-px bg-(--console-border-subtle)";

export const CATALOG_TOOLBAR_CONTROL_CLASS = cn(
  `
    h-auto! min-h-0 rounded-lg border border-(--console-border) bg-white! px-3
    py-[9px] text-[13px] font-medium text-(--console-text-link) shadow-none!
    focus-visible:border-(--console-accent)! focus-visible:outline-none
    data-[state=open]:border-(--console-accent)!
  `,
);

export const CATALOG_TOOLBAR_SEARCH_CONTROL_CLASS = cn(
  CATALOG_TOOLBAR_CONTROL_CLASS,
  `
    border-(--console-border-input) px-3.5 text-[13.5px] font-normal
    text-(--console-foreground)
    placeholder:text-foreground/45
  `,
);

export const CATALOG_FILTER_TRIGGER_HOVER_CLASS = cn(
  `
    **:text-inherit
    hover:bg-(--console-surface-muted)! hover:text-(--console-text-link)!
  `,
);
